module.exports = __webpack_public_path__ + "static/media/po-reman-2.68881375.png";